function toggleFeaturedJobs(checkbox) {
    const container = document.querySelector('.js_featuredJobsSection');
    console.log(checkbox.checked);

    if (container) {
        if (checkbox.checked) {
            container.classList.add('careersLandingSection--blue');
            container.classList.remove('hideFeaturedJobs');
        } else {
            container.classList.remove('careersLandingSection--blue');
            container.classList.add('hideFeaturedJobs');
        }
    }
}

function init() {
    const checkbox = document.querySelector('.js_showFeaturedJobs__checkbox');
    console.log('featured-jobs-toggle');
    console.log('checkbox');
    console.log(checkbox);
    
    if (checkbox) {
        console.log('addEventListener');
        checkbox.addEventListener('change', e => toggleFeaturedJobs(checkbox));
    }
}

$(document).ready(init);
